import styled from 'styled-components';
import React, {FC} from 'react';

import {fontSizesMixins, mediaBreakpointDown} from '../../../../lib/styleVariables';

export interface TitleDescProps {
  description: React.ReactNode;
  title: React.ReactNode;
}

const StyledWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const StyledTitle = styled.h1`
  ${fontSizesMixins.h1()};
  margin: 0;
  max-width: 808px;

  ${mediaBreakpointDown('tablet')} {
    ${fontSizesMixins.h2()};
  }
`;

const StyledDescription = styled.p`
  ${fontSizesMixins.text2Spread()};
  margin-bottom: 0;
  margin-top: 12px;
  max-width: 600px;

  ${mediaBreakpointDown('tablet')} {
    ${fontSizesMixins.text2()};
  }
`;

export const TitleDesc: FC<TitleDescProps> = props => {
  const {description, title} = props;

  return (
    <StyledWrapper>
      <StyledTitle>{title}</StyledTitle>
      <StyledDescription>{description}</StyledDescription>
    </StyledWrapper>
  );
};
